export default __webpack_public_path__ + "static/media/famatel.83f9fc23.jpg";